import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'notifications'
})
export class NotificationsPipe implements PipeTransform {
  transform(order, channel?: string) {
    let lastNotification = order.notifications.
      filter(el => {
        /* if (order.status == 'processing' || order.status == 'waiting')
           return true;*/
        return el.channel == channel;
      }).sort((a, b) => {
        return (+new Date(b.queued_at) - +new Date(a.queued_at));
      })[0];
      

    if (!lastNotification) return '';

    //  if (lastNotification.channel == 'phone')
    //   if (lastNotification.type !== 'start_search_again' && lastNotification.type !== 'cab_arrived') return '';

    let res = lastNotification.channel + '-' + lastNotification.status;
    console.log('TCL: NotificationsPipe -> transform -> res', res)
    return res;

    /* if (status == 'processing') {
       let i = 0;
       let filtredItem = items.filter((item) => {
         i++;
         return item.type == 'trip_canceled';
       });
       filtredItem.sort((a, b) => {
         return +new Date(b.queued_at) - +new Date(a.queued_at);
       });
       if (filtredItem.length) {
         return filtredItem[0].status;
       } else {
         return null;
       }
     } else {
       let filtredItem = items
         .filter((item) => {
           return item.type == 'accepted';
         })
         .sort((a, b) => {
           return +new Date(b.queued_at) - +new Date(a.queued_at);
         });
       if (filtredItem.length) {
         return filtredItem[0].status;
       } else {
         return null;
       }
     }*/
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/pipe/notifications.pipe.ts